import React from "react";
import { Tabs } from "antd";
import { Overview } from "../overview";
import { SalesReportDashboard } from "../salesreportdashboard";
import "./index.css";

const OverviewDashboard = () => {
  const items = [
    {
      key: "1",
      label: "Overview",
      children: <Overview />,
    },
    {
      key: "2",
      label: "Sales Report",
      children: <SalesReportDashboard />,
    },
  ];

  return (
    <div className="overview-dashboard-main">
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};

export default OverviewDashboard;